"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("@antv/util");
function parseFields(field) {
    if (_.isArray(field)) {
        return field;
    }
    return field.split('*');
}
exports.parseFields = parseFields;
//# sourceMappingURL=parse-fields.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/util/parse-fields.js
// module id = 600
// module chunks = 37